import React from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { st, classes } from './SessionDetails.st.css';
import { DailySession } from '../../../../../service-page-view-model/scheduling-section-view-model/schedulingSectionViewModel';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import LocationIcon from '../../../../../assets/icons/Location.svg';
import { useCurrentLocation } from '../useCurrentLocation';
import { All_LOCATIONS_ID } from '../../../../../service-page-view-model/scheduling-location-view-model/schedulingLocationViewModel';
import { useVisibilityCheck } from '../../../hooks/useVisibilityCheck';
import { useAddVisibilityClass } from '../../../hooks/useAddVisibilityClass';

export const SessionDetails: React.FC<DailySession> = ({
  startTime,
  dateRange,
  durationText,
  durationAriaLabel,
  staffName,
  locationName,
  allDay,
}) => {
  const { isRTL, isMobile } = useEnvironment();
  const { shouldBeVisible } = useVisibilityCheck();
  const { addVisibilityClass } = useAddVisibilityClass();
  const staffVisibility = shouldBeVisible('scheduleStaffVisibility');
  const durationVisibility = shouldBeVisible('scheduleDurationVisibility');
  const currentLocation = useCurrentLocation();
  const showLocationName = currentLocation === All_LOCATIONS_ID;

  const timeDisplay = dateRange
    ? durationText && durationVisibility
      ? `${dateRange} (${durationText})`
      : dateRange
    : startTime;

  const showDuration = () => {
    if (dateRange || !durationVisibility || (!durationText && !durationAriaLabel)) {
      return null;
    }
    return (
      <>
        {durationText ? (
          <div
            dir={isRTL ? 'rtl' : undefined}
            className={addVisibilityClass(
              classes.detailWrapper,
              classes.scheduleDurationVisibility,
              'scheduleDurationVisibility',
            )}
            aria-hidden
          >
            <Text className={classes.duration} data-hook="duration-text">
              {durationText}
            </Text>
          </div>
        ) : null}
        {durationAriaLabel ? (
          <div
            className={addVisibilityClass(
              classes.srOnly,
              classes.scheduleDurationVisibility,
              'scheduleDurationVisibility',
            )}
            data-hook="duration-aria-label"
          >
            {durationAriaLabel}
          </div>
        ) : null}
      </>
    );
  };
  const showStaff = () =>
    staffVisibility && staffName ? (
      <div
        className={addVisibilityClass(
          classes.detailWrapper,
          classes.scheduleStaffVisibility,
          'scheduleStaffVisibility',
        )}
      >
        <Text className={classes.staff} data-hook="staff-name">
          {staffName}
        </Text>
      </div>
    ) : null;
  return (
    <div className={st(classes.root, { isRTL, isMobile })}>
      {showLocationName && locationName ? (
        <div className={classes.details}>
          <div className={classes.detailWrapper}>
            <Text
              className={classes.startTime}
              data-hook="start-time"
              tagName={allDay ? 'span' : 'time'}
              aria-label={dateRange ? `${dateRange}${durationAriaLabel && durationVisibility ? ` (${durationAriaLabel})` : ''}` : undefined}
            >
              {timeDisplay}
            </Text>
          </div>
          <div
            className={`${classes.detailWrapper} ${classes.locationWrapper}`}
          >
            <LocationIcon
              width="1em"
              height="1.4em"
              className={classes.locationIcon}
            />
            <Text className={classes.location} data-hook="location">
              {locationName}
            </Text>
          </div>
        </div>
      ) : (
        <Text
          className={classes.startTime}
          data-hook="start-time"
          tagName={allDay ? 'span' : 'time'}
          aria-label={dateRange ? `${dateRange}${durationAriaLabel && durationVisibility ? ` (${durationAriaLabel})` : ''}` : undefined}
        >
          {timeDisplay}
        </Text>
      )}
      <div className={classes.details}>
        {showDuration()}
        {showStaff()}
      </div>
    </div>
  );
};
